export const BUILD_VERSION = '1789520860';
